// GlobalDialog.js
import "./GlobalDialog.css";
import React, { useEffect, useState } from "react";
import { registerDialog } from "./dialogService";

const GlobalDialog = () => {
  const [dialogProps, setDialogProps] = useState(null);

  useEffect(() => {
    registerDialog((props) => setDialogProps(props));
  }, []);

  const handleConfirm = () => {
    dialogProps?.onConfirm?.();
    setDialogProps(null);
  };

  const handleCancel = () => {
    dialogProps?.onCancel?.();
    setDialogProps(null);
  };

  if (!dialogProps) return null;

  return (
    <div className="dialog-backdrop">
      <div className="dialog-box">
        <h3>{dialogProps.title || "Message"}</h3>
        <div>
            {dialogProps.message.split('\n').map((line, index) => (
              <p key={index} style={{ margin: 0 }}>{line}</p>
            ))}
        </div>
        <div className="dialog-buttons">
          <button onClick={handleConfirm}>OK</button>
          {dialogProps.showCancel && <button onClick={handleCancel}>Cancel</button>}
        </div>
      </div>
    </div>
  );
};

export default GlobalDialog;
